/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { PropsWithChildren } from 'react';

import { Typography2, breakpoints } from '@coursera/cds-core';

import EditorNotification from 'bundles/personalization-settings/components/EditorNotification';

const styles = {
  row: css`
    display: grid;
    grid-template-columns: 240px minmax(0, 1fr);
    gap: var(--cds-spacing-100);
    align-items: center;

    ${breakpoints.down('sm')} {
      grid-template-columns: minmax(0, 1fr);
    }
  `,
  content: css`
    min-width: 0;
  `,
  rowContainer: css`
    display: grid;
    gap: var(--cds-spacing-200);
  `,
};

export type SettingRowProps = PropsWithChildren<{
  /** The field label, shown in the left column. */
  label: string;
  /** The label id that we can use for accessibility */
  labelId?: string;
  /** The current save status for this row; renders as an announced notification below the editor. */
  notificationType?: 'success' | 'error';
}>;

const SettingRow = ({ label, labelId, notificationType, children }: SettingRowProps) => (
  <div css={styles.rowContainer}>
    <div css={styles.row}>
      <Typography2 component="p" variant="subtitleMedium" id={labelId}>
        {label}
      </Typography2>
      <div css={styles.content}>{children}</div>
    </div>
    <div aria-live="polite">{notificationType && <EditorNotification type={notificationType} />}</div>
  </div>
);

export default SettingRow;
